import Vue from 'vue'
import Router from 'vue-router'
import Account from './components/Account'
import Admin from './components/Admin'
import AdminEmail from './components/Admin/Email'
import AdminLogin from './components/Admin/Login'
import Billing from './components/Billing'
import BillingAccount from './components/BillingAccount'
import DirectLink from './components/DirectLink'
import FleetSettings from './components/settings/fleet/Index'
import FMSSettings from './components/settings/fleet/FMS'
import Help from './components/Help'
import HelpAbout from './components/Help/About'
import Home from './components/Home'
import Inbox from './components/Inbox/Index'
import Login from './components/Login'
import MyAccount from './components/settings/MyAccount'
import NotFound from './components/NotFound'
import Onboarding from './components/Onboarding'
import PasswordReset from './components/PasswordReset'
import Provisioning from './components/Provisioning'
import ScheduleSettings from './components/settings/fleet/Schedule'
import Settings from './components/settings/Index'
import POISettings from './components/settings/fleet/POI'
import UnitDetails from './components/UnitDetails'
import UnitFiles from './components/UnitFiles'
import UnitMap from './components/UnitMap'
import UnitReports from './components/UnitReports'
import UnitSettings from './components/settings/fleet/Unit'
import UnitStatus from './components/UnitStatus'
import UnitTable from './components/UnitTable'
import UnitVPN from './components/UnitVPN'
import UnitVPNInfo from './components/UnitVPN/Info'
import UnitVPNLogs from './components/UnitVPN/Logs'
import UnitVPNSDCard from './components/UnitVPN/SDCard'
import UnitVPNUpdate from './components/UnitVPN/Update'
import UserAccessControl from './components/settings/uac/Index'
import UACByFleet from './components/settings/uac/Fleet'
import UACByUser from './components/settings/uac/User'
import { debug, baseUrl } from './globals'

Vue.use(Router)

export let routes = [
  { path: '/',  component: Home },
  { path: '/alerts', component: Inbox },
  { path: '/u/:id([0-9]+)', component: UnitDetails, props: true,
    children: [
      { path: 's', component: UnitStatus, meta: { title: 'Status' } },
      { path: 'f', component: UnitFiles, meta: { title: 'Files' } },
      { path: 't', component: UnitTable, meta: { title: 'Table' } },
      { path: 'm', component: UnitMap, meta: { title: 'Map', keepAlive: true } },
      { path: 'r', component: UnitReports, meta: { title: 'Reports' } },
      { path: 'v', component: UnitVPN, meta: { title: 'VPN', noPrefix: true }, name: 't1',
        children: [
          { path: 'i', component: UnitVPNInfo, meta: { title: 'VPN — Info', noPrefix: true }, name: 't5' },
          { path: 'l', component: UnitVPNLogs, meta: { title: 'VPN — Logs', noPrefix: true }, name: 't2' },
          { path: 's', component: UnitVPNSDCard, meta: { title: 'VPN — SD Card', noPrefix: true }, name: 't3' },
          { path: 'u', component: UnitVPNUpdate, meta: { title: 'VPN — Software Update', noPrefix: true }, name: 't4' },
        ],
      },
    ],
  },
  { path: '/s', component: Settings },
  { path: '/s/f/:fid([0-9]+)', component: FleetSettings, props: true },
  { path: '/s/f/:fid([0-9]+)/f', component: FMSSettings, props: true },
  { path: '/s/f/:fid([0-9]+)/u', component: UnitSettings, props: true },
  { path: '/s/f/:fid([0-9]+)/p', component: POISettings, props: true },
  { path: '/s/f/:fid([0-9]+)/s', component: ScheduleSettings, props: true },
  { path: '/s/me', component: MyAccount },
  { path: '/s/uac', component: UserAccessControl },
  { path: '/s/uac/f/:id([0-9]+)', component: UACByFleet, props: true },
  { path: '/s/uac/u/:email', component: UACByUser, props: true },
  { path: '/a', component: Admin,
    children: [
      { path: 'email', component: AdminEmail, meta: { title: 'Admin — Mass Email' } },
      { path: 'login', component: AdminLogin, meta: { title: 'Admin — Login' } },
    ],
  },
  { path: '/preferences', component: Account },
  { path: '/billing', component: Billing },
  { path: '/billing/:aid([0-9]+)', component: BillingAccount, props: true },
  { path: '/provisioning', component: Provisioning },
  { path: '/link', component: DirectLink, meta: { offline: true, anonymous: true } },
  { path: '/login', component: Login, meta: { offline: true, anonymous: true } },
  { path: '/h', component: Help, meta: { offline: true },
    children: [
      { path: 'about', component: HelpAbout, meta: { title: 'About' } },
    ],
  },
  { path: '/onboarding', component: Onboarding, meta: { anonymous: true } },
  { path: '/onboarding/:code([a-zA-Z0-9]+)', component: Onboarding, meta: { anonymous: true }, props: true },
  { path: '/password-reset', component: PasswordReset, meta: { anonymous: true } },
  { path: '/password-reset/:code([a-zA-Z0-9]+)', component: PasswordReset, meta: { anonymous: true }, props: true },
  { path: '*', component: NotFound },
]

export default new Router({
  base: baseUrl,
  mode: debug ? 'hash' : 'history',
  routes: routes,
})
